// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__ffc {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  background-color: var(--ring-sidebar-background-color);
  border: 1px solid var(--ring-line-color);
  border-radius: var(--ring-border-radius);

  padding: calc(2 * var(--ring-unit));
}

.filterInfo__e27 {
  overflow: hidden;
  width: 100%;

  .mainInfo__eb9 {
    .exclusion__bbb & {
      color: var(--ring-warning-color);
    }

    .products__ab9 {
      margin-left: calc(var(--ring-unit) * 0.5);
    }
  }

  .filterSecondaryInfo__aee {
    color: var(--ring-secondary-color);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    .label__a7a {
      font-size: var(--ring-font-size-smaller);
    }

    .value__b7f {
      margin-left: calc(var(--ring-unit) * 0.5);
    }
  }

  .mainInfo__eb9 + .filterSecondaryInfo__aee {
    margin-top: calc(var(--ring-unit) * 0.5);
  }
}

.actions__b6f {
  display: flex;
  align-items: center;
  margin-left: calc(2 * var(--ring-unit));

  .action__e04 {
    height: calc(var(--ring-unit) * 2);
    width: calc(var(--ring-unit) * 2);
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .action__e04 + .action__e04 {
    margin-left: calc(var(--ring-unit) * 1.5);
  }

  .remove__d7d {
    span {
      color: var(--ring-icon-error-color);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/applications/tools-filter/filter/filter.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;;EAE9B,sDAAsD;EACtD,wCAAwC;EACxC,wCAAwC;;EAExC,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,WAAW;;EAEX;IACE;MACE,gCAAgC;IAClC;;IAEA;MACE,yCAAyC;IAC3C;EACF;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;;IAEvB;MACE,wCAAwC;IAC1C;;IAEA;MACE,yCAAyC;IAC3C;EACF;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;;EAEvC;IACE,kCAAkC;IAClC,iCAAiC;IACjC,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE;MACE,mCAAmC;IACrC;EACF;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  background-color: var(--ring-sidebar-background-color);\n  border: 1px solid var(--ring-line-color);\n  border-radius: var(--ring-border-radius);\n\n  padding: calc(2 * var(--ring-unit));\n}\n\n.filterInfo {\n  overflow: hidden;\n  width: 100%;\n\n  .mainInfo {\n    .exclusion & {\n      color: var(--ring-warning-color);\n    }\n\n    .products {\n      margin-left: calc(var(--ring-unit) * 0.5);\n    }\n  }\n\n  .filterSecondaryInfo {\n    color: var(--ring-secondary-color);\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n\n    .label {\n      font-size: var(--ring-font-size-smaller);\n    }\n\n    .value {\n      margin-left: calc(var(--ring-unit) * 0.5);\n    }\n  }\n\n  .mainInfo + .filterSecondaryInfo {\n    margin-top: calc(var(--ring-unit) * 0.5);\n  }\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  margin-left: calc(2 * var(--ring-unit));\n\n  .action {\n    height: calc(var(--ring-unit) * 2);\n    width: calc(var(--ring-unit) * 2);\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .action + .action {\n    margin-left: calc(var(--ring-unit) * 1.5);\n  }\n\n  .remove {\n    span {\n      color: var(--ring-icon-error-color);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__ffc`,
	"filterInfo": `filterInfo__e27`,
	"mainInfo": `mainInfo__eb9`,
	"exclusion": `exclusion__bbb`,
	"products": `products__ab9`,
	"filterSecondaryInfo": `filterSecondaryInfo__aee`,
	"label": `label__a7a`,
	"value": `value__b7f`,
	"actions": `actions__b6f`,
	"action": `action__e04`,
	"remove": `remove__d7d`
};
export default ___CSS_LOADER_EXPORT___;
